@if (!configurationsLoaded || !member()) {
<ng-content></ng-content>
}
@if (configurationsLoaded && member()) {
@if (!!moduleConfig?.ExpertsSupported){
<div class="clearfix">
  @if (member()?.IsLoggedIn) {
  <ul id="top-navigation" class="logged-in">
    <li class="cta_btn">
      <a href="/Login/LogOut">Logout</a>
    </li>
    <li class="cta_btn"><a href="/My-Account/">My Account</a></li>
    <li class="account-balance">
      <span id="lblName">Hi, {{member()?.Name}}</span>
      <span>Balance: <a class="AccountBalanceDisplay" id="lnkBalance" href="/My-Account/MakePayment/">{{member()?.AvailableBalance?.AmountFormatted}}</a></span>
    </li>
  </ul>
  } @else {
  <ul id="top-navigation">
    <li class="cta_btn"><a [href]="moduleConfig?.UrlCreateAccount ?? '/Create-Account/'">Register</a></li>
    <li class="cta_btn"><a href="/Login/">Login</a></li>
    @if (alternateLanguages?.length>0) {
    <li class="flags">
      <span class="select-country">Select Country</span>
      <div id="divFlags">
        @for (alternateLanguage of alternateLanguages; track alternateLanguage?.Language) {
        @switch (alternateLanguage?.Language) {
        @case ('en-gb') {
        <a href="{{pageUrlForLanguage(alternateLanguage)}}" title="United Kingdom" [class.active]="isLanguageActive(alternateLanguage)" hreflang="en-gb">
          <span class="hidden">United Kingdom</span>
          <svg><use href="#icon-flag-uk"></use></svg>
        </a>
        }
        @case ('en-ie') {
        <a href="{{pageUrlForLanguage(alternateLanguage)}}" title="Ireland" [class.active]="isLanguageActive(alternateLanguage)" hreflang="en-ie">
          <span class="hidden">Ireland</span>
          <svg><use href="#icon-flag-eire"></use></svg>
        </a>
        }
        }
        }
      </div>
    </li>
    }
  </ul>
  }
</div>
} @else {
  @if (member()?.IsLoggedIn) {
<div id="js-nav-collapse" class="nav-collapse" data-page-section="navigation_top">
  <div id="header-menu" class="clearfix">
    <div id="topNavigation" class="clearfix">
      <div class="settingsMenu dashboard-toggle">
        <!--Hard code menu options for now-->
        <ul class="menu">
          <li class="first last">
            <a href="/ProfileAndSettings/">My Account</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div id="header-logged-in" class="clearfix">
    <div id="profileOptions">
      <ul class="menu clearfix">
        <li class="clearfix">
          <a id="btnLogOut" class="pink button" href="/Login/LogOut">Log out</a>
        </li>
      </ul>
    </div>
  </div>
</div>
  }
  @else {
<div id="js-nav-collapse" class="nav-collapse" data-page-section="navigation_top">
  <div id="header-logged-out" class="clearfix">
    <ul class="buttons">
      <li><a href="/Register/" class="small button pink">Join Now</a></li>
      <li><a href="/Login/" class="small button pink">Log In</a></li>
    </ul>
  </div>
</div>
  }
}
}
